import type { EventInvitationStatus, Sex } from "./enums";
import type { Database, Tables } from "./types.gen";

export type EventUIModel = Tables<"events"> & {
  author: Tables<"profiles">;
  author_org: Partial<Tables<"organisations">>;
  author_gym: Partial<Tables<"gyms">>;
};

export enum EventsDateFilter {
  UPCOMING = "Upcoming",
  PAST = "Past",
}

export enum EventDetailsTab {
  Details = "details",
  Registrations = "registrations",
  FightCards = "fight-cards",
  Tournament = "tournament",
}

export enum EventManageTab {
  Info = "info",
  RegistrationManagement = "registration-management",
  FightCards = "fight-cards",
  Tournament = "tournament",
}

export interface EventsFilter {
  dateFilter: EventsDateFilter;
  searchQuery: string;
}

export interface EventFighter {
  id: string;
  event_id: string;
  fighter_id: string;
  created_by: string;
  status: EventInvitationStatus;
  rejection_message: string | null;
  event_categories: string[];
  fighter_snapshot: {
    win_count: number;
    win_count_pro: number;
    draw_count: number;
    draw_count_pro: number;
    lose_count: number;
    lose_count_pro: number;
    total_match_count: number;
    total_match_count_pro: number;
  };
  player: {
    id: string;
    avatar_url: string;
    name: string;
    country_iso2: string;
    total_match_count: number;
    total_match_count_pro: number;
    weight: number;
    height: number;
    sex: Sex;
    date_of_birth?: string | null;
    win_count: number;
    win_count_pro: number;
    lose_count: number;
    lose_count_pro: number;
    draw_count: number;
    draw_count_pro: number;
    gym: {
      id: string;
      created_by: string;
      avatar_url: string;
      name: string;
      country_iso: string;
    };
  };
}
